<ds-error-message [errorList]="errorList"></ds-error-message>
<div class="replace-vehicle year-vin">
  <form [formGroup]="yearVinForm" (ngSubmit)="submit()">
    <div class="row">
      <div class="column twelve md-six">
        <ds-form-control-container
          [labelText]="'Vehicle Identification Number (VIN)'"
          [control]="yearVinForm.controls['vin']"
        >
          <input
            id="vin"
            class="fill"
            formControlName="vin"
            data-cy="replaceVehicleVinInput"
            (input)="verifyVin()"
          />
          <ds-form-control-message
            [control]="yearVinForm.controls['vin']"
          ></ds-form-control-message>
          @if (isSameVin) {
            <div class="error-600-text caption">
              {{ sameVINErrorMessage }}
            </div>
          }
        </ds-form-control-container>
      </div>
    </div>

    <div class="row margin-top-10">
      <div class="column twelve md-six">
        <ds-form-control-container
          [labelText]="'Vehicle Year'"
          [control]="yearVinForm.controls['year']"
        >
          <select
            id="year"
            class="icon fill"
            formControlName="year"
            data-cy="replaceVehicleYearSelect"
          >
            <option value="unset" selected disabled>Select a vehicle year</option>
            @for (year of years; track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
          <span class="icon-chevron-down"></span>
          <ds-form-control-message
            [control]="yearVinForm.controls['year']"
          ></ds-form-control-message>
        </ds-form-control-container>
      </div>
    </div>

    @if (hasError | async) {
      <div class="error-600-text caption">
        {{ errorMessage }}
      </div>
    }

    <div class="row pad-top-20">
      <div class="column twelve">
        Did you know your policy includes new vehicle coverage for
        {{ gracePeriodDays$ | async }} days from the purchase date?
        <a href="javascript:void(0)" (click)="toggleGracePeriod()">More details.</a>
      </div>
    </div>

    @if (yearVinForm.contains('odometer')) {
      <div>
        <div class="row margin-top-30">
          <div class="column twelve md-six">
            <h4 class="heading-sub-section">New Vehicle Mileage</h4>
            <ds-form-control-container
              [labelText]="'Odometer'"
              [control]="yearVinForm.controls['odometer']"
            >
              <input
                id="odometer"
                class="fill"
                formControlName="odometer"
                data-cy="replaceVehicleOdometerInput"
              />
              <ds-form-control-message
                [control]="yearVinForm.controls['odometer']"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
      </div>
    }

    <div class="row callToAction">
      <div class="column twelve">
        <span class="md-float-right">
          <a
            class="pad-horizontal-20"
            (click)="cancel()"
            dsContent
            [contentPath]="'shared.cancel'"
          ></a>
          <button
            ds-button
            type="submit"
            [disabled]="
              !yearVinForm.valid ||
              !yearVinForm.dirty ||
              (loading | async) ||
              !(roleService.isAuthorized('replacevehiclequote_submit') | async) ||
              isSameVin
            "
            data-cy="replaceVehicleVinLookupButton"
          >
            @if (!(loading | async)) {
              <span>Next</span>
            }
            @if (loading | async) {
              <span>Loading...</span>
            }
          </button>
        </span>
      </div>
    </div>
  </form>
</div>
<ds-grace-period
  [gracePeriodDays]="gracePeriodDays$ | async"
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
></ds-grace-period>
